export default __webpack_public_path__ + "static/media/paper-plane.bf3802d0.svg";